import {
  IconName,
  Separator,
  TitledContainer,
  Toolbar,
  ToolbarOption,
} from '@infotech-soe/erp-ui-kit';
import React, { memo, ReactNode, useCallback, useMemo } from 'react';

import { CommandListEntryType } from '../../../services/commands/CommandViewModel';
import { useStyles } from '../category/styles';
import { OptionType } from '../commands/CommandsToolbar';

import { TreeCommand } from './useTreeCommands';

interface Props {
  children: ReactNode;
  commands?: Array<TreeCommand | Separator>;
  hideCommands?: boolean;
  title: string;
}

const TreeTitledContainer = (props: Props) => {
  const { children, commands, hideCommands, title } = props;
  const classes = useStyles();
  const toolbarOptions: Array<ToolbarOption<string>> | undefined = useMemo(
    () =>
      commands?.map(item =>
        item.type === CommandListEntryType.COMMAND
          ? {
              type: OptionType.BUTTON,
              disabled: item.disabled,
              icon: item.icon as IconName,
              label: item.label,
              name: item.value,
            }
          : item
      ),
    [commands]
  );

  const handleSelect = useCallback(
    (name: string) => {
      commands?.find(cmd => {
        if (cmd.type === CommandListEntryType.COMMAND && cmd.value === name) {
          cmd.handler();
          return true;
        }
      });
    },
    [commands]
  );

  return (
    <TitledContainer
      title={
        !hideCommands && (
          <div className={classes.treeTitle}>
            <div className="text-ellipsis">{title}</div>
            {toolbarOptions && (
              <Toolbar
                className="dataset-toolbar"
                options={toolbarOptions}
                onSelect={handleSelect}
                lastShownIndex={2}
              />
            )}
          </div>
        )
      }
    >
      {children}
    </TitledContainer>
  );
};

export default memo(TreeTitledContainer);
